import { getCookie, setCookie, deleteCookie } from '@/helpers/cookies'

export default {
  namespaced: true,
  state() {
    return {
      userLoginStatus: getCookie( 'simply_flights_auth' ) === '1',
      loginPass: 'test123' // TODO :: Create a settings page and a password entry in db wp-options and a password field.
    }
  },
  mutations: {
    AUTHORIZE_USER( state ) {
      state.userLoginStatus = true
      setCookie( 'simply_flights_auth', '1' )
    }
  }
}